import { render, staticRenderFns } from "./PropertyReviews.vue?vue&type=template&id=c27d7d06&scoped=true&"
import script from "./PropertyReviews.vue?vue&type=script&lang=js&"
export * from "./PropertyReviews.vue?vue&type=script&lang=js&"
import style0 from "./PropertyReviews.vue?vue&type=style&index=0&id=c27d7d06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27d7d06",
  null
  
)

export default component.exports